import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";

import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/Opleidingen Background Image.png";
import icon1 from "../../assets/images/Play IT 1.png";
import icon2 from "../../assets/images/Play IT 2.png";
import icon3 from "../../assets/images/Play IT 3.png";
import { loadBlogs } from "../../utils/loadBlogs"; // Import the loadBlogs function

import BlogCards from "../../components/BlogCards";
export default function Nieuws() {
  const welcomeHeading = "Nieuws";
  const [blogPosts, setBlogPosts] = useState([]);

  useEffect(() => {
    // Load blogs and select the first 3
    const blogs = loadBlogs();
    setBlogPosts(blogs);
    // setBlogPosts(blogs.slice(0, 3));
    // console.log(blogs);
  }, []);

  // useEffect(() => {
  //   console.log("Blog posts loaded:", blogPosts);
  // }, blogPosts);

  return (
    <div>
      <Helmet>
        <title>Nieuws</title>
        <meta
          name="description"
          content="Krijg training met DD-Group over veiligheid, brandpreventie en cybersecurity via Play-IT. Voor interne transport- en veiligheidstrainingen kun je contact met ons opnemen, en wij verbinden je met 'The Knowledge' voor het beste aanbod via onze speciale referentie."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />

        <BlogCards heading="Blogs" cards={blogPosts} columns={3} />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}
